import { FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link } from 'react-router';
import { useIsOnline } from '../../contexts/NetworkStatusContext';

const OfflineBanner: React.FC<{ linkPath?: string }> = ({ linkPath }) => {
  const isOnline = useIsOnline();
  if (isOnline) return null;
  return (
    <FlexBox
      justifyContent="center"
      alignItems="center"
      bgcolor={(theme) => theme.palette.gray?.[100]}
      borderRadius={8}
      py={0.5}
      px={2}
    >
      <Typography
        {...(linkPath ? { component: Link, to: linkPath } : {})}
        variant={'body3'}
        color={'textTertiary'}
        sx={{ textDecoration: 'none' }}
      >
        You are offline
      </Typography>
    </FlexBox>
  );
};

export default OfflineBanner;
